import { getCookie } from "./cookies";

export const getToken = () => {
  return {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("SUPER")}`,
    },
  };
};
